import { render } from "./CashRegisterView.vue?vue&type=template&id=60d848e2"
import script from "./CashRegisterView.vue?vue&type=script&lang=js"
export * from "./CashRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__